<template>
    <transition
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="opened"
            class="flex items-center gap-3 border-b border-new-amber-200 bg-new-amber-50 px-4 py-3"
        >
            <Clock class="size-5 shrink-0 text-new-amber-600" />

            <div class="flex-1 text-sm">
                <span class="font-medium text-new-amber-900">
                    Your Plugin trial ends
                    <span v-if="date">on {{ format(new Date(date), 'MMMM d, yyyy') }}</span>.
                </span>
                <span class="text-new-amber-700">
                    Want to extend your trial or discuss pricing? Our team is ready to help you get the most out of TOPOL Plugin.
                </span>
            </div>

            <div class="flex items-center gap-2 shrink-0">
                <Button size="sm" @click="handleContactSales">
                    Contact sales
                </Button>
                <Button
                    variant="ghost"
                    size="icon"
                    class="size-8 text-new-amber-700 hover:text-new-amber-900 hover:bg-new-amber-100"
                    aria-label="Dismiss"
                    @click="opened = false"
                >
                    <X class="size-4" />
                </Button>
            </div>
        </div>
    </transition>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { format } from 'date-fns'
import { Clock, X } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'

defineProps<{
    date: string | undefined
}>()

const opened = ref(true)

const handleContactSales = () => {
    window.open('https://go.topol.io/meetings/martin-dluzansky/topol-demo-web-emb', '_blank', 'noopener')
}
</script>
